export type PresentationEventContextMode = 'ALLOCATION' | 'SCHEDULE';

export const PRESENTATION_EVENT_CONTEXT_MODE_ROUTE_DATA_KEY =
  'presentationEventContextMode';

export function getPresentationEventContextMode(
  routeData: Record<string, unknown>
): PresentationEventContextMode {
  return routeData[PRESENTATION_EVENT_CONTEXT_MODE_ROUTE_DATA_KEY] ===
    'SCHEDULE'
    ? 'SCHEDULE'
    : 'ALLOCATION';
}
